module.exports = __webpack_public_path__ + "img/2020-4.b74d55f0.jpg";